export default __webpack_public_path__ + "static/JS-621f6061172a58343b60a9fadbe3378c.png";